var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-group" },
    [
      !_vm.invert
        ? [
            _c(
              "p",
              {
                staticClass: "utext ma-0",
                class: { "text-small": _vm.smallHeader },
                staticStyle: { "white-space": "pre-line" }
              },
              [_vm._v(" " + _vm._s(_vm.utext) + " ")]
            ),
            _c(
              "p",
              {
                staticClass: "btext",
                class: [
                  _vm.tgap,
                  {
                    "text-large": _vm.large,
                    "text-xl": _vm.xl,
                    "btext-bold": _vm.btextBold
                  }
                ],
                staticStyle: { "white-space": "pre-line" }
              },
              [_vm._v(" " + _vm._s(_vm.btext) + " ")]
            )
          ]
        : [
            _c(
              "p",
              {
                staticClass: "btext",
                class: {
                  "text-large": _vm.large,
                  "text-xl": _vm.xl,
                  "btext-bold": _vm.btextBold
                },
                staticStyle: { "white-space": "pre-line" }
              },
              [_vm._v(" " + _vm._s(_vm.btext) + " ")]
            ),
            _c(
              "p",
              {
                staticClass: "utext",
                class: [
                  _vm.tgap,
                  { "text-small": _vm.smallHeader, "ma-0": !_vm.tgap }
                ],
                staticStyle: { "white-space": "pre-line" }
              },
              [_vm._v(" " + _vm._s(_vm.utext) + " ")]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }